import { createSlice } from '@reduxjs/toolkit';
import { OMSAPI } from '../../../../../API'; // Adjust based on your architectural paths
import { fetchIntegratedPlatform } from '../../integratedSlice';

export const fishbowlSlice = createSlice({
    name: 'fishbowl',
    initialState: {
        progress: {
            data: {
                endpoint_url: "",
                port_number: "4131",
                username: "",
                carrier_id: ""
            },
            message: "",
            loading: false,
            hasErrors: false,
            isApproved: false // Tracks if Fishbowl server administration has approved the app
        },
        configure: {
            data: {},
            message: "",
            loading: false,
            hasErrors: false
        }
    },
    reducers: {
        fetchFishbowlDetails: (state) => {
            return {
                ...state,
                progress: {
                    ...state.progress,
                    loading: true
                }
            }
        },
        fetchFishbowlDetailsSuccess: (state, action) => {
            return {
                ...state,
                progress: {
                    message: action?.payload?.data?.message || "",
                    data: action?.payload?.data?.data || state.progress.data,
                    isApproved: action?.payload?.data?.data?.is_approved ?? false,
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        fetchFishbowlDetailsFailure: (state, action) => {
            return {
                ...state,
                progress: {
                    ...state.progress,
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        postFishbowlConfigure: (state) => {
            return {
                ...state,
                configure: {
                    ...state.configure,
                    loading: true
                }
            }
        },
        postFishbowlConfigureSuccess: (state, action) => {
            return {
                ...state,
                configure: {
                    data: {},
                    message: action?.payload?.data?.message || "",
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        postFishbowlConfigureFailure: (state, action) => {
            return {
                ...state,
                configure: {
                    message: action?.payload?.data?.message || "",
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        resetFishbowlConfigureStateDetails: (state) => {
            return {
                ...state,
                configure: {
                    data: {},
                    message: '',
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        resetFishbowlStateDetails: (state) => {
            return {
                ...state,
                progress: {
                    data: {
                        endpoint_url: "",
                        port_number: "4131",
                        username: "",
                        carrier_id: ""
                    },
                    message: "",
                    loading: false,
                    hasErrors: false,
                    isApproved: false
                },
                configure: {
                    data: {},
                    message: '',
                    loading: false,
                    hasErrors: false,
                }
            }
        },
    }
});

// Export sync action hooks
export const { 
    fetchFishbowlDetails, fetchFishbowlDetailsSuccess, fetchFishbowlDetailsFailure,
    postFishbowlConfigure, postFishbowlConfigureSuccess, postFishbowlConfigureFailure, 
    resetFishbowlConfigureStateDetails, resetFishbowlStateDetails 
} = fishbowlSlice.actions;

// --- API ASYNC THUNK ACTIONS ---

/**
 * 1. Post and Save Fishbowl Configuration Matrix 
 */
export const configureFishbowlStore = data => dispatch => {
    dispatch(postFishbowlConfigure());
    try {
        OMSAPI.post('/fishbowl/configure', data)
            .then(function (response) {
                dispatch(postFishbowlConfigureSuccess(response));
                // Update global platform listing registry context state
                dispatch(fetchIntegratedPlatform());
            }).catch(function (error) {
                dispatch(postFishbowlConfigureFailure(error?.response));
            })
    }
    catch (error) {
        dispatch(postFishbowlConfigureFailure(error?.response));
    }
};

/**
 * 2. Fetch Active Profile Integration Settings Configuration State
 */
export const fetchFishbowlData = data => dispatch => {
    dispatch(fetchFishbowlDetails());
    try {
        OMSAPI.post('/fishbowl/show', data)
            .then(function (response) {
                dispatch(fetchFishbowlDetailsSuccess(response));
            }).catch(function (error) {
                dispatch(fetchFishbowlDetailsFailure(error?.response));
            })
    }
    catch (error) {
        dispatch(fetchFishbowlDetailsFailure(error?.response));
    }
};

/**
 * 3. Verify Administrative Authorization Pipeline Token Connection Handshake
 */
export const verifyFishbowlApproval = data => dispatch => {
    dispatch(fetchFishbowlDetails());
    try {
        OMSAPI.post('/fishbowl/verify-token', data)
            .then(function (response) {
                dispatch(fetchFishbowlDetailsSuccess(response));
            }).catch(function (error) {
                dispatch(fetchFishbowlDetailsFailure(error?.response));
            })
    }
    catch (error) {
        dispatch(fetchFishbowlDetailsFailure(error?.response));
    }
};

export const resetFishbowlConfigureState = () => dispatch => {
    dispatch(resetFishbowlConfigureStateDetails());
};

export const resetFishbowlState = () => dispatch => {
    dispatch(resetFishbowlStateDetails());
};

export default fishbowlSlice.reducer;